import styled from 'styled-components';

export const StyledSignIn = styled.div`
  position: relative;

  .si-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 200px;

    &-left {
      white-space: nowrap;

      h2 {
        font-size: 37px;
        font-weight: 600;
        line-height: 45px;
        text-align: left;
        color: var(--color-white);
        margin-bottom: 68px;
      }

      p {
        text-align: right;
        color: var(--color-white);
        font-size: 29px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;

        &:first-of-type {
          margin-bottom: 30px;
          font-size: 32px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          text-align: left;
        }

        > span {
          display: block;
          color: var(--color-white);
        }
      }
    }

    &-right {
      width: 476px;
      max-height: 628px;
      padding: 75px 67px 47px;
      border-radius: 20px;
      background: var(--main-gradient);

      &-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 42px;
        gap: 12px;

        > img {
          width: 50%;
        }
      }

      &-bottom {
        margin-top: 54px;

        &-top {
          margin-bottom: 22px;
          color: var(--color-white);
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 28px;

          > span {
            cursor: pointer;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: var(--color-white);

            &:first-child {
              position: relative;

              &:after {
                content: '';
                position: absolute;
                right: -15px;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 12px;
                background: var(--color-white);
              }
            }
          }
        }

        &-middle {
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          white-space: nowrap;
          color: var(--color-white);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;

          > span {
            color: var(--color-white);

            &:first-child {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
`;
